import styled from 'styled-components'

export interface StyledNonSearchableProps {
  $disabled?: boolean
  $isPlaceholder?: boolean
}

export const StyledNonSearchable = styled.div<StyledNonSearchableProps>`
  ${({ theme, $disabled, $isPlaceholder }) => `
      pointer-events: ${$disabled ? 'none' : 'auto'};
      width: 100%;
      min-width: 0;
      text-align: left;
      font-size: ${theme.fontSizes.bodySmall};
      font-weight: ${theme.fontWeights.regular};
      line-height: ${theme.sizes[5]};
      color: ${$isPlaceholder ? theme.colors.neutral300 : theme.colors.black};
      margin-right: ${theme.sizes.l};
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: flex;
      align-items: center;
    `}
`
